import styled from '@emotion/styled';
import { TrackedProgress } from '@chronos/components/TrackedProgress/styled';
import {
  AvatarsGroup,
  EditEstimateButton,
  Estimate,
  TotalEstimate,
} from '@chronos/components/Estimate/styled';

export const Labels = styled.div`
  padding: 0 10px;
`;

export const Sublitle = styled.div`
  color: #5e6c84;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  margin-top: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 4px;
  margin-right: 8px;
  margin-bottom: 4px;
  margin-left: 0;
  line-height: 20px;
`;

export const CardName = styled.div`
  min-height: 32px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 20px;
  white-space: nowrap;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const CardDescription = styled.div`
  max-height: 30%;
  overflow: scroll;
  padding: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  > span {
    white-space: pre-line;
    word-break: break-word;
    overflow-wrap: break-word;
  }
`;

export const TrackedProgressWrapper = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${TrackedProgress} {
    flex-grow: 0;
    padding: 0;
    margin: 0;
  }
  ${AvatarsGroup} {
    gap: 3px;
  }
  ${Estimate} {
    ${TotalEstimate} {
      flex-grow: 1;
    }
    ${EditEstimateButton} {
      flex-grow: 1;
      justify-self: end;
      justify-content: end;
    }
  }
`;

export const NotFoundMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex: 1;
`;
